import React, { useState, useContext } from "react";
import Slider from "react-slick";
import Image from "../designLayouts/Image";
import { UserConfigContext } from "../../context/UserConfigContext";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Banner = () => {
  const [dotActive, setDotActive] = useState(0);
  const [showArrows, setShowArrows] = useState(false);
  const { config1 } = useContext(UserConfigContext);

  const ArrowStyle = `absolute top-1/2 transform -translate-y-1/2 p-2 bg-gray-500 text-white rounded-full cursor-pointer z-10 transition-opacity duration-300`;

  const PrevArrow = ({ onClick }) => (
    <div
      className={`${ArrowStyle} left-4 ${showArrows ? 'opacity-100' : 'opacity-0'}`}
      onClick={onClick}
    >
      <FaChevronLeft />
    </div>
  );

  const NextArrow = ({ onClick }) => (
    <div
      className={`${ArrowStyle} right-4 ${showArrows ? 'opacity-100' : 'opacity-0'}`}
      onClick={onClick}
    >
      <FaChevronRight />
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (prev, next) => {
      setDotActive(next);
    },
    appendDots: dots => (
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ul style={{ display: "flex", gap: "8px", padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: i => (
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: i === dotActive ? "white" : "gray", // Blanco si activo, gris si no
          transition: "background-color 0.3s",
          cursor: "pointer",
        }}
      />
    ),
  };

  return (
    <div
      className="relative w-full bg-white m-0 p-0"
      onMouseEnter={() => setShowArrows(true)}
      onMouseLeave={() => setShowArrows(false)}
    >
      <Slider {...settings}>
        {(Array.isArray(config1.carousel) ? config1.carousel : [])
          .filter(item => item.activo === "1")
          .map((item, index) => (
            <div key={index}>
              <Image
                imgSrc={item.rutaimagen}
                className="w-full h-[500px] object-cover"
              />
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default Banner;
